<ngx-spinner [name]="name" [bdColor]="background" size="medium" color="#f93d66" type="line-scale-pulse-out"
  [fullScreen]="fullScreen">
  <p *ngIf="title" class="title">{{ title }}</p>
  <p *ngIf="subtitle" class="subtitle">{{ subtitle }}</p>
  <p *ngIf="text" class="loading newlines">{{ text }}</p>
</ngx-spinner>
